// react/utils
import { setMilliseconds, setSeconds } from 'date-fns';

// types
import type { PickerValidDate } from '@mui/x-date-pickers-pro';

/** Drops the seconds and milliseconds a period never carries a meaning for. */
export const toMinute = (date: Date) => setMilliseconds(setSeconds(date, 0), 0);

/**
 * The app renders the pickers under `AdapterDateFns`, so they hand back a `Date`. Their value
 * type is still the union of every adapter the app pulls in -- `PickerValidDate` resolves
 * through a lookup interface that each adapter augments, and `ControlledFields/*` nest their
 * own `AdapterDayjs` providers -- so the Dayjs branch has to be narrowed away here. It can go
 * once those providers move over.
 */
export const toDate = (value: PickerValidDate | null): Date | null =>
  value == null ? null : value instanceof Date ? value : value.toDate();
